// Sidebar panes
export const SIDEBAR_PANE_DEFAULT = 'default';
export const SIDEBAR_PANE_LIKES_LIST = 'likes';



// WEBPACK FOOTER //
// ./src/js/apps/ddo/consts.js